import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing-section',
  templateUrl: './billing-section.component.html',
  styleUrls: ['./billing-section.component.scss']
})
export class BillingSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
